//create a new component for the chat module
import React, {
  useState,
  useEffect,
} from "react";
import { useTranslation } from 'react-i18next';
import Messages from "./Messages";
import SidebarInfo from "./SidebarInfo";
import MessageInput from "./MessageInput";
import {
  getContacts,
  getMessages,
  updateContact,
  saveSentMessage,
  saveSentMediaMessage,
  searchContact,
} from "../services/localdatabase.service";
import { sendMessage, uploadFileMessage, sendMediaMessage, findContact } from "../services/wapib.service";
import { socket } from "../services/Socket";
import { useAuth } from "../services/auth.service";
import Contacts from "./Contacts";
import ResponsiveChatAppBar from "./ResponsiveChatAppBar";
import { isMobile } from "react-device-detect";
import Push from "push.js";
import LinearProgress from "@mui/material/LinearProgress";
import Chip from '@mui/material/Chip';
import { useParams } from "react-router-dom";
import MessagesSkeleton from "./MessagesSkeleton";

export default function Chat() {
  const { t } = useTranslation();
  const [currentContact, setCurrentContact] = useState({
    "_id": [
      [
        [
          "50769237925"
        ]
      ]
    ],
    "contact": [
      [
        [
          {
            "profile": {
              "name": "Chat"
            },
            "wa_id": ""
          }
        ]
      ]
    ]
  });
  const [mobileTimer, setMobileTimer] = useState(undefined);
  const [contacts, setContacts] = useState([]);
  const [sentContacts, setSentContacts] = useState([]);
  const [unreadContacts, setUnreadContacts] = useState([]);
  const [automatedContacts, setAutomatedContacts] = useState([]);
  const [searchSkip, setSearchSkip] = useState(0);
  const [searchLimit] = useState(20);
  const [searchPagination, setSearchPagination] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newMessage, setNewMessage] = useState(null);
  const { user, logout, currentConfig, changeCurrentConfig, getCurrentConfig } = useAuth();
  const [currentPage, setCurrentPage] = useState("contacts");
  const [sendingMessage, setSendingMessage] = useState(false);
  const [uploadDetails, setUploadDetails] = useState(null);
  const [datatype, setDatatype] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const params = useParams();
  const [currentContactID, setCurrentContactID] = useState(params.wa_id);

  const handleNewMessage = (data) => {
    console.log('handleNewMessage called with data:', data);
    try {
      // Validate data structure before processing
      if (!data || !data.entry || !Array.isArray(data.entry) || data.entry.length === 0) {
        console.warn('Invalid data structure in handleNewMessage:', data);
        return;
      }

      const entry = data.entry[0];
      if (!entry || !entry.changes || !Array.isArray(entry.changes) || entry.changes.length === 0) {
        console.warn('Invalid entry structure in handleNewMessage:', entry);
        return;
      }

      const change = entry.changes[0];
      if (!change || !change.value) {
        console.warn('Invalid change structure in handleNewMessage:', change);
        return;
      }

      //check if message or status
      if (change.value.statuses && Array.isArray(change.value.statuses) && change.value.statuses.length > 0) {
        console.log('Status update received:', change.value.statuses[0]);
        console.log('Current contact:', currentContact?.Celular);
        console.log('Status recipient:', change.value.statuses[0].recipient_id);
        if (
          currentContact &&
          currentContact.Celular ===
          change.value.statuses[0].recipient_id
        ) {
          let messageStatus = change.value.statuses[0];
          // Ensure messages is an array before filtering
          const currentMessages = Array.isArray(messages) ? messages : [];
          let messageStatusExists = currentMessages.filter((messageStatusFromState) => {
            try {
              if (messageStatusFromState.entry && messageStatusFromState.entry[0] && 
                  messageStatusFromState.entry[0].changes && messageStatusFromState.entry[0].changes[0] &&
                  messageStatusFromState.entry[0].changes[0].value && messageStatusFromState.entry[0].changes[0].value.messages &&
                  messageStatusFromState.entry[0].changes[0].value.messages[0] &&
                  messageStatusFromState.entry[0].changes[0].value.messages[0].id === messageStatus.id) {
                return true;
              } else {
                return false;
              }
            } catch (error) {
              return false;
            }
          });
          if (messageStatusExists && messageStatusExists.length > 0) {
            messageStatusExists[0].entry[0].changes[0].value.statuses = messageStatusExists[0].entry[0].changes[0].value.statuses ? [...messageStatusExists[0].entry[0].changes[0].value.statuses, messageStatus] : [messageStatus];
            let newStatusMessages = currentMessages.filter((messageStatusFromState) => {
              try {
                if (messageStatusFromState.entry && messageStatusFromState.entry[0] && 
                    messageStatusFromState.entry[0].changes && messageStatusFromState.entry[0].changes[0] &&
                    messageStatusFromState.entry[0].changes[0].value && messageStatusFromState.entry[0].changes[0].value.messages &&
                    messageStatusFromState.entry[0].changes[0].value.messages[0] &&
                    messageStatusFromState.entry[0].changes[0].value.messages[0].id !== messageStatus.id) {
                  return true;
                } else {
                  return false;
                }
              } catch (error) {
                return false;
              }
            }
            );
            setMessages(sortMessages([...newStatusMessages, messageStatusExists[0]]));
          }
        }
      } else if (change.value.contacts && Array.isArray(change.value.contacts) && change.value.contacts.length > 0 &&
                 change.value.messages && Array.isArray(change.value.messages) && change.value.messages.length > 0) {

        //check if the wa_id is the same as the current contact
        if (
          currentContact &&
          currentContact.Celular ===
          change.value.contacts[0].wa_id
        ) {
          //check if the message not exists on the messages array
          let message = change.value.messages[0];
          // Ensure messages is an array before filtering
          const currentMessages = Array.isArray(messages) ? messages : [];
          let messageExists = currentMessages.filter((messageFromState) => {
            try {
              if (messageFromState.entry && messageFromState.entry[0] && 
                  messageFromState.entry[0].changes && messageFromState.entry[0].changes[0] &&
                  messageFromState.entry[0].changes[0].value && messageFromState.entry[0].changes[0].value.messages &&
                  messageFromState.entry[0].changes[0].value.messages[0]) {
                return (
                  messageFromState.entry[0].changes[0].value.messages[0].id ===
                  message.id
                );
              } else {
                return false;
              }
            } catch (error) {
              return false;
            }
          });
          if (messageExists && messageExists.length > 0) {
            //replaces the message with the new one
            let newMessages = currentMessages.filter((messageFromState) => {
              try {
                if (messageFromState.entry && messageFromState.entry[0] && 
                    messageFromState.entry[0].changes && messageFromState.entry[0].changes[0] &&
                    messageFromState.entry[0].changes[0].value && messageFromState.entry[0].changes[0].value.messages &&
                    messageFromState.entry[0].changes[0].value.messages[0]) {
                  return (
                    messageFromState.entry[0].changes[0].value.messages[0].id !==
                    message.id
                  );
                } else {
                  return false;
                }
              } catch (error) {
                return false;
              }
            }
            );
            setMessages(sortMessages([...newMessages, data]));
          } else {
            // Ensure messages is an array before spreading
            const currentMessages = Array.isArray(messages) ? messages : [];
            setMessages(sortMessages([...currentMessages, data]));
          }
          let messagesContainer = document.getElementById("messagesContainer");
          if (messagesContainer) {
            messagesContainer.scrollTop = messagesContainer.scrollHeight;
          }
        } else {
          // Process contact list updates for all users (removed role restriction)
          console.log('Processing contact list update for new message');
          //check if the contact exists
          let contactExists = contacts.filter((contact) => {
            try {
              return (
                contact.Celular ===
                change.value.contacts[0].wa_id
              );
            } catch (error) {
              return false;
            }
          });
          if (contactExists.length > 0) {
            //delete the contact
            let orderedContacts = contacts.filter(
              (contact) => {
                try {
                  return contact.Celular !==
                    change.value.contacts[0].wa_id
                } catch (error) {
                  return false;
                }
              }
            );
            //change the lastMessage and increment newMessages count
            contactExists[0].lastMessage = change.value.messages[0];
            contactExists[0].lastMessageTimestamp = change.value.messages[0].timestamp;
            contactExists[0].newMessages = (contactExists[0].newMessages || 0) + 1;
            console.log('Updated contact message count:', contactExists[0].Celular, 'new count:', contactExists[0].newMessages);

            console.log('Updating existing contact in list:', contactExists[0].Celular);
            setContacts([contactExists[0], ...orderedContacts]);
          } else {
            //add the contact
            let newContact = {
              _id: change.value.contacts[0].wa_id,
              NombreCompleto: change.value.contacts[0].profile?.name || 'Unknown',
              Celular: change.value.contacts[0].wa_id,
              newMessages: 1,
              sentMessage: false,
              lastMessage: change.value.messages[0],
            };
            //put the new contact on the top
            let newContacts = contacts;
            console.log('Adding new contact to list:', newContact.Celular);

            setContacts([newContact, ...newContacts]);
          }
        }
      }
    } catch (error) {
      console.log(error + "data is metadata not messages");
    }
  };

  const onSelectTemplate = (e, template) => {
    e.preventDefault();
    //delete variables localstorage
    localStorage.removeItem('variables');
    setSelectedTemplate(template);
    let draftTemplate = {
      "_id": "643ea3911f2627d1316ds214f",
      "entry": [
        {
          "changes": [
            {
              "field": "messages",
              "value": {
                "contacts": [
                  {
                    "profile": {
                      "name": "GENESIS SEGUROS"
                    },
                    "wa_id": "50763788349"
                  }
                ],
                "messages": [
                  {
                    "from": "50766289358",
                    "id": "wamid.HBgLNTA3NjM3ODgdzNDkVAgARGBI2RjEwRTk0MTRCNDg5NjM2REEA",
                    "text": {
                      "body": {
                        "name": template.name,
                        "editable": true,
                        "language": {
                          "policy": "deterministic",
                          "code": "es"
                        },
                        "components": [
                          {
                            "type": "header",
                            "parameters": [
                              {
                                "type": "video",
                                "video": {
                                  "link": "https://firebasestorage.googleapis.com/v0/b/segenesis-cotizador.appspot.com/o/notificaciones%2Fcumpleanos2022.mp4?alt=media&token=222ca809-c827-4e81-a888-e9fc32785c04"
                                }
                              }
                            ]
                          },
                          {
                            "type": "body",
                            "parameters": [
                              {
                                "type": "text",
                                "text": "input text"
                              }
                            ]
                          }
                        ],
                        "_": "template"
                      }
                    },
                    "timestamp": (new Date().getTime() / 1000) + "",
                    "type": "text"
                  }
                ],
                "messaging_product": "whatsapp",
                "metadata": {
                  "display_phone_number": "50766289358",
                  "phone_number_id": null
                }
              }
            }
          ],
          "id": "105520548863497"
        }
      ],
      "object": "whatsapp_business_account"
    };

    //append the template to the messages
    // Ensure messages is an array before spreading
    const currentMessages = Array.isArray(messages) ? messages : [];
    let newMessagesAddTemplate = [...currentMessages, { _id: 0, entry: draftTemplate.entry }];
    setMessages(newMessagesAddTemplate);
  }

  const cancelTemplateMessage = (e) => {
    e.preventDefault();
    //eliminate the last message on messages
    // Ensure messages is an array before manipulating
    let newMessages = Array.isArray(messages) ? [...messages] : [];
    newMessages.pop();
    setMessages(newMessages);
    setSelectedTemplate(null);
  }


  const sendTemplateMessage = async (e) => {
    e.preventDefault();
    if (sendingMessage) return;
    if (!selectedTemplate) {
      setError("The template is empty");
      return;
    }
    try {
      //load variables from localstorage
      let variables = localStorage.getItem('variables');
      fetch(process.env.REACT_APP_BACKEND_API + "/messages/sendtemplatemessage", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": user.accessToken,
        },
        body: JSON.stringify({
          to: currentContact.Celular,
          templateID: selectedTemplate.name,
          parameters: variables ? JSON.parse(variables) : [],
          header: {
            image: selectedTemplate.image !== "" ? selectedTemplate.image : null,
            video: selectedTemplate.video !== "" ? selectedTemplate.video : null,
          },
          buttonParameters: []
        }),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("Something went wrong ...");
          }
        }
        )
        .then((data) => {
          data.contacts = [{ wa_id: currentContact.Celular, profile: { name: currentContact.NombreCompleto } }];
          if (data.entry)
            setNewMessage(data);

          // let newMessage = saveSentMessage({data:data}, currentContact.draft);
          // //eliminate the last message first
          // let newMessages = messages;
          // newMessages.pop();
          // newMessages.push({ _id: 0, entry: newMessage.entry });
          // setMessages(newMessages);
          // setCurrentContact({ ...currentContact, draft: selectedTemplate.name });
          // setSelectedTemplate(null);
        }
        )
        .catch((error) => {
          console.log(error);
          //drop the last message
          // Ensure messages is an array before manipulating
          let newMessages = Array.isArray(messages) ? [...messages] : [];
          newMessages.pop();
          setMessages(newMessages);
        });
    } catch (error) {
      setError("Error sending the message");
    }
  }

  useEffect(() => {
    if (currentContact) {
      //check if the draft property exists and is not empty
      if (currentContact.draft && currentContact.draft.trim() !== "") {
        updateContact(
          currentContact.wa_id,
          currentContact.lastMessage,
          currentContact.draft
        );
      }
    }
    setLoading(false);
  }, [currentContact, contacts]);

  useEffect(() => {
    if (newMessage != null) handleNewMessage(newMessage);
  }, [newMessage]);

  useEffect(() => {
    //scroll the container to bottom
    let messagesContainer = document.getElementById("messagesContainer");
    if (messagesContainer && messagesContainer.childNodes && messagesContainer.childNodes[0]) {
      messagesContainer.childNodes[0].scrollTop = messagesContainer.childNodes[0].scrollHeight;
    }
    // Ensure messages is an array before checking length
    if (Array.isArray(messages) && messages.length > 0) {
      const messagesContainer = document.getElementById("messagesContainer");
      const contactsContainer = document.getElementById("contactsContainer");
      if (messagesContainer) messagesContainer.classList.remove("hidden");
      if (contactsContainer) contactsContainer.classList.add("hidden");
      changeCurrentConfig({ currentPage: "messages", currentContact: currentContact });
    }
  }, [messages]);

  const [error, setError] = useState("");

  const [search, setSearch] = useState("");


  useEffect(() => {
    //loads the currentContact message on the first render
    if (currentContactID) {
      let contact = contacts.find((contact) => contact.Celular === currentContactID);
      if (contact) {
        setCurrentContact(contact);
        loadContactMessages(0, contact.inboxtype);
        setCurrentContactID(null);
      }
    }
  }, [contacts]);

  const firstData = async () => {
    try {
      setError("");
      //check if the messages on localstorage exists
      let newContacts = await getContacts(user.accessToken);
      
      // Handle case where newContacts is not an array
      if (!Array.isArray(newContacts)) {
        console.warn('getContacts returned non-array in firstData:', newContacts);
        setContacts([]);
        return;
      }
      
      if (currentContactID) {
        let currentPageContact = await findContact(user.accessToken, currentContactID);
        
        // Handle case where currentPageContact is not an array
        if (!Array.isArray(currentPageContact)) {
          console.warn('findContact returned non-array:', currentPageContact);
          currentPageContact = [];
        }
        
        //check if currentContactId exists on the contacts
        let contactExists = newContacts.filter((contact) => {
          try {
            return contact.Celular === currentContactID;
          } catch (error) {
            console.warn('Error filtering contact in firstData:', error, contact);
            return false;
          }
        });
        if (contactExists.length > 0) {
          //put on first
          newContacts = newContacts.filter((contact) => {
            try {
              return contact.Celular !== currentContactID;
            } catch (error) {
              console.warn('Error filtering contact in firstData:', error, contact);
              return false;
            }
          });
          newContacts.unshift(contactExists[0]);
        } else {

          //add to newContacts to the first
          if (currentPageContact.length > 0) {
            newContacts.unshift(currentPageContact[0]);
          }
        }
      }
      if (newContacts.length > 0) {
        setContacts(newContacts);
        changeCurrentConfig({ currentPage: "contacts", currentContact: null });
      }
      
      let newSentContacts = await getContacts(user.accessToken, "0", "sent");
      if (Array.isArray(newSentContacts) && newSentContacts.length > 0) {
        setSentContacts(newSentContacts);
      }
      
      let newUnreadContacts = await getContacts(user.accessToken, "0", "unread");
      if (Array.isArray(newUnreadContacts) && newUnreadContacts.length > 0) {
        setUnreadContacts(newUnreadContacts);
      }
      
      let newAutomatedContacts = await getContacts(user.accessToken, "0", "automated");
      if (Array.isArray(newAutomatedContacts) && newAutomatedContacts.length > 0) {
        setAutomatedContacts(newAutomatedContacts);
      }
    } catch (error) {
      console.error('Error in firstData:', error);
      setError("Error loading contacts");
    }
  };

  const handleSubmit = async (submitEvent) => {
    //check the submit for errors
    submitEvent.preventDefault();
    if (sendingMessage) return;
    let inputValueIs = submitEvent.target.value ? submitEvent.target.value : (submitEvent.target.childNodes[0].childNodes[3] ? submitEvent.target.childNodes[0].childNodes[3].value : "");
    if (submitEvent.target.value && submitEvent.target.value.trim() === "") {
      setError("The message is empty");
      return;
    } else if (submitEvent.target.childNodes[0].childNodes[3] && submitEvent.target.childNodes[0].childNodes[3].value === "") {
      setError("The message is empty");
      return;
    }
    try {
      if (datatype) {
        let result = await sendMediaMessage(
          currentContact.Celular,
          inputValueIs,
          uploadDetails.path,
          datatype
        );
        console.log('Media message sent successfully:', result);
        // Use the new function for media messages
        let newMessage = saveSentMediaMessage(
          result, 
          inputValueIs, 
          datatype, 
          process.env.REACT_APP_SOCKET_URL + "/" + uploadDetails.path
        );
        // Ensure messages is an array before spreading
        const currentMessages = Array.isArray(messages) ? messages : [];
        setMessages(sortMessages([...currentMessages, { _id: 0, entry: newMessage.entry }]));
        setCurrentContact({ ...currentContact, draft: "" });
        setUploadDetails(null);
        setDatatype(null);
        setSendingMessage(false);
        inputValueIs = "";
        return;
      }
      let newMessageResult = await sendMessage(
        currentContact.Celular,
        inputValue,
        user.accessToken
      );
      console.log('Message sent successfully:', newMessageResult);
      let newMessage = saveSentMessage(newMessageResult, inputValue);
      // Ensure messages is an array before spreading
      const currentMessages = Array.isArray(messages) ? messages : [];
      setMessages([...currentMessages, { _id: 0, entry: newMessage.entry }]);
      setCurrentContact({ ...currentContact, draft: "" });
      setInputValue("");
    } catch (error) {
      setError("Error sending the message");
    }
    setSendingMessage(false);
  };

  const handleFileUpload = async (e) => {
    e.preventDefault();
    if (sendingMessage) return;
    if (e.target.files.length === 0) {
      setError("The file is empty");
      return;
    }
    try {
      let form = e.target;
      const formData = new FormData();
      formData.append("file", form.files[0]);
      setUploadDetails({ filename: form.files[0].name, size: form.files[0].size });
      let newMessageResult = await uploadFileMessage(formData);
      setUploadDetails(newMessageResult.data);
      setDatatype(e.target.dataset.type);
    } catch (error) {
      setError("Error sending the message");
    }
    setSendingMessage(false);
  };

  const onFileUploadCancel = () => {
    setUploadDetails(null);
    setDatatype(null);
  }

  const onFileUploadClick = () => {
    console.log(uploadDetails.path);
  }

  useEffect(() => {
    async function fetchContacts() {
      try {
        const searchContacts = await getContacts(user.accessToken);

        // Handle case where searchContacts is not an array
        if (!Array.isArray(searchContacts)) {
          console.warn('getContacts returned non-array:', searchContacts);
          setContacts([]);
          return;
        }

        let filteredContacts = searchContacts.filter((contact) => {
          try {
            const nombreMatch = contact.asegurado?.NombreCompleto?.toLowerCase().includes(search.toLowerCase()) || false;
            const celularMatch = contact.asegurado?.Celular?.toLowerCase().includes(search.toLowerCase()) || false;
            const etiquetasMatch = contact.asegurado?.etiquetas?.map((etiqueta) => etiqueta.label.toLowerCase()).includes(search.toLowerCase()) || false;
            
            return nombreMatch || celularMatch || etiquetasMatch;
          } catch (error) {
            console.warn('Error filtering contact:', error, contact);
            return false;
          }
        });
        
        if (filteredContacts.length > 0) {
          setContacts(filteredContacts);
        }
        else {
          const searchResult = await searchContact(user.accessToken, search, searchSkip, searchLimit);
          
          // Handle new response format with data and pagination
          const apiContacts = searchResult?.data || [];
          const pagination = searchResult?.pagination || null;
          
          // Update pagination state
          setSearchPagination(pagination);
          
          // Handle case where apiContacts is not an array
          if (Array.isArray(apiContacts) && apiContacts.length > 0) {
            // If this is the first page (searchSkip === 0), replace contacts
            // Otherwise, append to existing contacts
            if (searchSkip === 0) {
              setContacts(apiContacts);
            } else {
              setContacts(prevContacts => [...prevContacts, ...apiContacts]);
            }
          } else {
            if (searchSkip === 0) {
              setContacts([]);
            }
          }
        }
      } catch (error) {
        console.error('Error in fetchContacts:', error);
        if (searchSkip === 0) {
          setContacts([]);
        }
      }
    }
    if (search !== "") {
      const timeoutId = setTimeout(() => fetchContacts(), 1000);
      return () => clearTimeout(timeoutId);
    } else {
      const timeoutId = setTimeout(() => firstData(), 1000);
      return () => clearTimeout(timeoutId);
    }
  }, [search, searchSkip]);


  const handleSearch = async (e) => {
    let value = e.target.value;
    setSearch(value);
    // Reset pagination when search changes
    setSearchSkip(0);
  };

  const onUpdateContact = (wa_id, attributes, inboxtype) => {
    try {
      const { NombreCompleto } = attributes;
      let contactsToUpdate = [];
      
      if (inboxtype === "sent") {
        //return only the contacts with sentMessage = true
        contactsToUpdate = Array.isArray(sentContacts) ? sentContacts.filter((contact) => {
          try {
            return contact.sentMessage;
          } catch (error) {
            console.warn('Error filtering sent contact:', error, contact);
            return false;
          }
        }) : [];
      } else if (inboxtype === "unread") {
        //return only the contacts with newMessages > 0
        contactsToUpdate = Array.isArray(unreadContacts) ? unreadContacts.filter((contact) => {
          try {
            return contact.newMessages > 0;
          } catch (error) {
            console.warn('Error filtering unread contact:', error, contact);
            return false;
          }
        }) : [];
      } else {
        contactsToUpdate = Array.isArray(contacts) ? contacts : [];
      }

      let newContacts = contactsToUpdate.map((contact) => {
        try {
          if (contact.Celular === wa_id) {
            return { ...contact, ...attributes };
          }
        } catch (error) {
          console.warn('Error updating contact:', error, contact);
        }
        return contact;
      });
      
      if (inboxtype === "sent") {
        //update also in localstorage
        localStorage.setItem(`contacts/sent${user.id}`, JSON.stringify(newContacts));
        setSentContacts(newContacts);
      } else if (inboxtype === "unread") {
        localStorage.setItem(`contacts/unread${user.id}`, JSON.stringify(newContacts));
        setUnreadContacts(newContacts);
      } else if (inboxtype === "automated") {
        localStorage.setItem(`contacts/automated${user.id}`, JSON.stringify(newContacts));
        setAutomatedContacts(newContacts);
      } else {
        setContacts(newContacts);
      }
    } catch (error) {
      console.error('Error in onUpdateContact:', error);
    }
  }

  const sortMessages = (inputMessages) => {
    // Ensure inputMessages is an array
    if (!Array.isArray(inputMessages)) {
      console.warn('sortMessages received non-array input:', inputMessages);
      return [];
    }
    
    let lastDate = "";
    let index = 0;
    while (inputMessages.length > index) {
      if (inputMessages[index].loadMore)
        return inputMessages;
      if (inputMessages[index].date) {
        lastDate = inputMessages[index].date;
        return inputMessages;
      }
      
      // Add safety checks for message structure
      try {
        if (!inputMessages[index].entry || 
            !inputMessages[index].entry[0] || 
            !inputMessages[index].entry[0].changes || 
            !inputMessages[index].entry[0].changes[0] ||
            !inputMessages[index].entry[0].changes[0].value ||
            !inputMessages[index].entry[0].changes[0].value.messages ||
            !inputMessages[index].entry[0].changes[0].value.messages[0]) {
          console.warn('Invalid message structure in sortMessages:', inputMessages[index]);
          index++;
          continue;
        }
        
        let date = new Date(
          inputMessages[index].entry[0].changes[0].value.messages[0].timestamp * 1000
        );
        let year = date.getFullYear();
        if (year > 2100) {
          date = new Date(
            inputMessages[index].entry[0].changes[0].value.messages[0].timestamp
          );
          year = date.getFullYear();
        }
        let day = date.getDate();
        let month = date.getMonth();
        let currentDate = `${day}/${month + 1}/${year}`;
        if (currentDate !== lastDate) {
          inputMessages.splice(index, 0, { date: currentDate });
          lastDate = currentDate;
        }
        index++;
      } catch (error) {
        console.warn('Error processing message in sortMessages:', error, inputMessages[index]);
        index++;
      }
    }
    return inputMessages;
  };

  const loadContactMessages = async (index, inboxtype) => {
    try {
      let updatedContact = {};
      if (inboxtype === "sent") {
        updatedContact = Array.isArray(sentContacts) && sentContacts[index] ? sentContacts[index] : {};
      } else if (inboxtype === "unread") {
        updatedContact = Array.isArray(unreadContacts) && unreadContacts[index] ? unreadContacts[index] : {};
      } else if (inboxtype === "automated") {
        updatedContact = Array.isArray(automatedContacts) && automatedContacts[index] ? automatedContacts[index] : {};
      } else {
        updatedContact = Array.isArray(contacts) && contacts[index] ? contacts[index] : {};
      }
      
      // Check if we have a valid contact
      if (!updatedContact.Celular) {
        console.warn('No valid contact found for index:', index, 'inboxtype:', inboxtype);
        setLoading(false);
        return;
      }
      
      // Clear messages immediately and show skeleton
      setMessages([]);
      setLoading(true);
      setCurrentContact({ ...updatedContact, draft: "", inboxtype: inboxtype });
      
      let messagesFromDB = await getMessages(updatedContact.Celular, 0, user.accessToken);
      
      // Handle case where messagesFromDB is not an array
      if (!Array.isArray(messagesFromDB)) {
        console.warn('getMessages returned non-array:', messagesFromDB);
        setMessages([]);
        setLoading(false);
        return;
      }
      
      let messagesArray = messagesFromDB.flat(2).filter((messageFromDB) => {
        try {
          return messageFromDB.entry[0].changes[0].value.messages[0];
        } catch (error) {
          console.warn('Error filtering message:', error, messageFromDB);
          return false;
        }
      });
      
      //update updatedContact
      //check if the user.ejecutivo is supervisor
      if (user.ejecutivo && !user.ejecutivo.department_supervisor) {
        updatedContact.newMessages = 0;
      }

      //append to first the load more button
      //check if there is more than 20 messages
      if (messagesArray.length >= 20)
        setMessages([{ loadMore: true }, ...sortMessages(messagesArray)]);
      else
        setMessages(sortMessages(messagesArray));
      onUpdateContact(updatedContact.Celular, { newMessages: updatedContact.newMessages }, inboxtype)
      if (mobileTimer)
        clearInterval(mobileTimer);
      if (isMobile)
        loadTimer();
    } catch (error) {
      console.error('Error in loadContactMessages:', error);
      setLoading(false);
    }
  };

  const loadMoreContactMessages = async () => {
    try {
      setLoading(true);
      
      // Check if we have a valid currentContact
      if (!currentContact?.Celular) {
        console.warn('No valid currentContact found');
        setLoading(false);
        return;
      }
      
      // Ensure messages is an array before accessing length
      const currentMessagesLength = Array.isArray(messages) ? messages.length : 0;
      let messagesFromDB = await getMessages(currentContact.Celular, currentMessagesLength, user.accessToken);
      
      // Handle case where messagesFromDB is not an array
      if (!Array.isArray(messagesFromDB)) {
        console.warn('getMessages returned non-array in loadMoreContactMessages:', messagesFromDB);
        setLoading(false);
        return;
      }
      
      let messagesArray = messagesFromDB.flat(2).filter((messageFromDB) => {
        try {
          return messageFromDB.entry[0].changes[0].value.messages[0];
        } catch (error) {
          console.warn('Error filtering message in loadMoreContactMessages:', error, messageFromDB);
          return false;
        }
      });
      
      if (messagesArray.length > 0) {
        if (messagesArray.length < 20) {
          messagesArray.pop();
        } else {
          messagesArray.unshift({ loadMore: true });
        }
        // Ensure messages is an array before manipulating
        let messagesOld = Array.isArray(messages) ? [...messages] : [];
        messagesOld.shift();

        setMessages(messagesArray.concat(messagesOld));
      }
    } catch (error) {
      console.error('Error in loadMoreContactMessages:', error);
    } finally {
      setLoading(false);
    }
  }


  useEffect(() => {
    if (loading) return;
    setLoading(true);
    firstData();
    // Ensure pushID is always valid
    let pushID = user.roles.includes("ROLE_ADMIN") ? "" : (user.ejecutivo?._id || user.id || "");
    
    // Listen to user-specific channel for messages
    console.log('Setting up socket listeners for user:', user.id, 'with pushID:', pushID);
    socket.on("message" + pushID, (data) => {
      console.log('User received message on channel "message' + pushID + '":', data);
      setNewMessage(data);
    });
    
    // For non-admin users, also listen to admin channel for status updates
    if (!user.roles.includes("ROLE_ADMIN")) {
      socket.on("message", (data) => {
        // Only process status updates (not new incoming messages)
        try {
          console.log('Non-admin user received message from admin channel:', data);
          if (data && data.entry && data.entry[0] && data.entry[0].changes && data.entry[0].changes[0] && 
              data.entry[0].changes[0].value && data.entry[0].changes[0].value.statuses) {
            console.log('Processing status update from admin channel');
            setNewMessage(data);
          } else {
            console.log('Message from admin channel is not a status update, ignoring');
          }
        } catch (error) {
          console.warn('Error processing status update from admin channel:', error);
        }
      });
    }
    
    socket.on("assignContact" + pushID, (data) => {
      Push.create("Genesis Interno", {
        body: "Te han asignado al cliente " + data.NombreCompleto + " " + data.Celular,
        icon: "/icon.png",
        timeout: 4000,
        onClick: function () {
          window.focus();
          this.close();
        }
      })
    });
    socket.on('pushNotification' + pushID, (data) => {
      try {
        let message = data.message.entry[0].changes[0].value.messages[0];
        let textbody = "";

        if (typeof message.text.body === 'string') {
          textbody = message.text.body.substring(0, 100);
        } else if (message.text.body.name) {
          textbody = message.text.body.name;
        } else if (message.text.body) {
          textbody = JSON.stringify(message.text.body);
        }

        if (!textbody || textbody.length === 0) {
          textbody = "Nuevo mensaje";
        } else if (textbody.length > 100) {
          textbody = textbody.substring(0, 100);
        }

        let contact = message.from;
        Push.create(contact, {
          body: textbody,
          icon: "/icon.png",
          timeout: 4000,
          onClick: function () {
            window.focus();
            this.close();
          }
        })
      } catch (error) {
        console.log(error);
      }
    })
    return () => {
      // Clean up socket listeners
      socket.off("message" + pushID);
      if (!user.roles.includes("ROLE_ADMIN")) {
        socket.off("message");
      }
      socket.off("assignContact" + pushID);
      socket.off('pushNotification' + pushID);
    };
  }, []);

  const loadTimer = () => {


    var temptimer = setTimeout(() => {
      const counterTimer = document.getElementById("timeleft");
      if (counterTimer) {
        setMobileTimer(setInterval(() => {
          let timeleft = counterTimer.innerHTML;
          document.getElementById("timeleftmobile").innerHTML = timeleft;
        }, 10000));
        clearInterval(temptimer);
      }
    }, 5000);
  }

  const loadMoreContacts = async (e, inboxtype) => {
    e.preventDefault();

    setLoading(true);
    try {
      let newContacts = [];
      if (inboxtype === "sent") {
        newContacts = await getContacts(user.accessToken, sentContacts.length, inboxtype);
        if (Array.isArray(newContacts) && newContacts.length > 0) {
          if (newContacts.length < 20) {
            newContacts.pop();
          }
          setSentContacts(newContacts);
        }
      } else if (inboxtype === "unread") {
        newContacts = await getContacts(user.accessToken, unreadContacts.length, inboxtype);
        if (Array.isArray(newContacts) && newContacts.length > 0) {
          if (newContacts.length < 20) {
            newContacts.pop();
          }
          setUnreadContacts(newContacts);
        }
      } else if (inboxtype === "automated") {
        newContacts = await getContacts(user.accessToken, automatedContacts.length, inboxtype);
        if (Array.isArray(newContacts) && newContacts.length > 0) {
          if (newContacts.length < 20) {
            newContacts.pop();
          }
          setAutomatedContacts(newContacts);
        }
      } else {
        newContacts = await getContacts(user.accessToken, contacts.length);
        if (Array.isArray(newContacts) && newContacts.length > 0) {
          if (newContacts.length < 20) {
            newContacts.pop();
          }
          setContacts(newContacts);
        }
      }
    } catch (error) {
      console.error('Error in loadMoreContacts:', error);
    } finally {
      setLoading(false);
    }
  }

  const loadMoreSearchResults = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Check if there are more pages available
      if (searchPagination && searchPagination.hasMore) {
        // Increment skip for next page
        const nextSkip = searchSkip + searchLimit;
        setSearchSkip(nextSkip);
        
        // The fetchContacts useEffect will automatically trigger with the new searchSkip
        // and append the new results to the existing contacts
      }
    } catch (error) {
      console.error('Error in loadMoreSearchResults:', error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {isMobile && <ResponsiveChatAppBar contact={currentContact} />}
      <div className={`shadow-lg rounded-lg overflow-hidden ${isMobile ? 'h-[calc(100vh-64px)]' : 'h-[calc(100vh-80px)]'}`}>
        <div className="md:flex md:flex-row md:justify-between bg-white h-full">
          {
            <Contacts contacts={contacts} unreadContacts={unreadContacts} automatedContacts={automatedContacts} sentContacts={sentContacts} loadContactMessages={loadContactMessages} search={search} handleSearch={handleSearch} setLoading={setLoading} loadMoreContacts={loadMoreContacts} loadMoreSearchResults={loadMoreSearchResults} searchPagination={searchPagination} />
          }
          {
            <div className="w-full flex flex-col hidden md:block chat-background" id="messagesContainer" style={{ width: '65%', display: 'flex', flexDirection: 'column', height: '100%' }}>
              <div
                className="flex flex-col overflow-y-scroll flex-1"
              >
                {loading ? (
                  <MessagesSkeleton count={8} />
                ) : (
                  Array.isArray(messages) &&
                  messages.map((message, index) => {
                    if (message.loadMore)
                      return (
                        <div
                          className="text-center text-white text-sm mb-5 cursor-pointer"
                          onClick={loadMoreContactMessages}
                        >
                          <span className="bg-blue-500 rounded-lg p-2 cursor-pointer">
                            {t('chat.loadMore')}
                          </span>
                        </div>
                      );
                    if (message.date)
                      return (
                        <div className="text-center text-sm mb-5">
                          <span className="bg-stone-500 rounded-lg p-2">
                            {message.date}
                          </span>
                        </div>
                      );
                    return <Messages key={index} message={message} messages={messages} sendTemplateMessage={sendTemplateMessage} cancelTemplateMessage={cancelTemplateMessage} />;
                  })
                )}
              </div>
              {uploadDetails &&
                (uploadDetails.path ? <div className="pt-2 pb-1 bg-white border-t border-gray-200">
                  <Chip
                    variant="outlined"
                    onDelete={onFileUploadCancel}
                    onClick={onFileUploadClick}
                    label={uploadDetails.filename} />
                </div> :
                  <div className="pt-2 pb-1 bg-white border-t border-gray-200">
                    {t('chat.uploading')} {uploadDetails.filename} {(uploadDetails.size / 1024).toFixed(2)}KB
                    <LinearProgress />
                  </div>)
              }
              {
                isMobile && <div id="timeleftmobile" className="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"></div>
              }
              {currentContact && currentContact.Celular && (
                <div className="bg-white border-t border-gray-200 mt-auto">
                  <MessageInput
                    onSubmit={(e) => handleSubmit(e)}
                    onFileUpload={(e) => handleFileUpload(e)}
                    inputValue={inputValue}
                    setInput={(e) => setInputValue(e.target.value)}
                  />
                </div>
              )}
            </div>
          }
          <SidebarInfo contact={currentContact} onUpdateContact={onUpdateContact} onSelectTemplate={onSelectTemplate} />
        </div>
      </div>
    </>
  );
}